import { deviceUsageDTOSchema, hostReportRowDTOSchema, inviteFunnelDTOSchema, visitBreakdownDTOSchema, visitOccupancyDTOSchema, visitorComplianceDTOSchema, visitSummaryDTOSchema, visitTimelineDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const breakdownSchema = dataEnvelopeSchema(visitBreakdownDTOSchema);
const timelineSchema = dataEnvelopeSchema(visitTimelineDTOSchema);
const summarySchema = dataEnvelopeSchema(visitSummaryDTOSchema);
const hostsSchema = listEnvelopeSchema(hostReportRowDTOSchema);
const occupancySchema = dataEnvelopeSchema(visitOccupancyDTOSchema);
const inviteFunnelSchema = dataEnvelopeSchema(inviteFunnelDTOSchema);
const deviceUsageSchema = dataEnvelopeSchema(deviceUsageDTOSchema);
const complianceSchema = dataEnvelopeSchema(visitorComplianceDTOSchema);
/** The four export methods below all ask for CSV, and `visits.exportCsv` spells the same
 *  header inline; one constant here keeps this file from repeating it four times. */
const CSV_ACCEPT = 'text/csv';
export function createAnalyticsResource(transport) {
    return {
        async breakdown(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/breakdown`,
                schema: breakdownSchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async timeline(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/timeline`,
                schema: timelineSchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async summary(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/summary`,
                schema: summarySchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async hosts(query) {
            return transport.request({
                path: `${WEB_API_PREFIX}/analytics/hosts`,
                schema: hostsSchema,
                query: {
                    from: query.from,
                    to: query.to,
                    locationId: query.locationId,
                    page: query.page,
                    pageSize: query.pageSize,
                    sort: query.sort,
                },
            });
        },
        async occupancy(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/occupancy`,
                schema: occupancySchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async invites(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/invites`,
                schema: inviteFunnelSchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async devices(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/devices`,
                schema: deviceUsageSchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async compliance(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/analytics/compliance`,
                schema: complianceSchema,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
            return envelope.data;
        },
        async exportTrafficCsv(query) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/analytics/traffic/export`,
                accept: CSV_ACCEPT,
                query: {
                    from: query.from,
                    to: query.to,
                    locationId: query.locationId,
                    series: query.series,
                },
            });
        },
        async exportHostsCsv(query) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/analytics/hosts/export`,
                accept: CSV_ACCEPT,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
        },
        async exportDevicesCsv(query) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/analytics/devices/export`,
                accept: CSV_ACCEPT,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
        },
        async exportComplianceCsv(query) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/analytics/compliance/export`,
                accept: CSV_ACCEPT,
                query: { from: query.from, to: query.to, locationId: query.locationId },
            });
        },
    };
}
//# sourceMappingURL=analytics.js.map